import { ChangeEvent, useState } from "react";

import { SectionsColorList, SectionProps } from "@/types";

import { colorListVariant, type ColorListVariantProps } from "./color-list.variants";

export type UseColorListProps = ColorListVariantProps & SectionProps<SectionsColorList>;

export const useColorList = (props: UseColorListProps) => {
  const { className = "", data, sectionName } = props;
  const { defaultValue } = data;

  const [currentValue, setCurrentValue] = useState<"hex" | "cmyk">(defaultValue);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(event.target.value as "hex" | "cmyk");
  };

  const styles = colorListVariant();

  return {
    className,
    styles,
    data,
    sectionName,
    currentValue,
    onChange: handleChange,
  };
};
